import { aggregator } from "./consts";
/**
 * Util method for fixing user miskey on activation month. if they pass 9/25 instead of 09/25, the ActivateCard mutation will fail.
 * @param {string} expirationMonth the expiration month of the user's new card.
 * @return {string}
 */
function formatExpirationMonth({ expirationMonth }) {
  if (expirationMonth.length > 1) {
    return expirationMonth;
  }

  let newExpirationMonth = expirationMonth;

  if (expirationMonth.length === 1 && expirationMonth !== "0") {
    newExpirationMonth = `0${expirationMonth}`;
  }

  return newExpirationMonth;
}

/**
 * Util method that checks to see if the current payment method is a finicity account that will return invalid banking information
 * @param {string} pendingPaymentMethod the payment method that is being validated against invalid finicity IDs
 * @param {array} invalidIds the array of finicity invalid IDs
 * @return {boolean} returns a boolean representing whether or not the payment method is blacklisted.
 * This is decided after filtering by the aggregator and mapping for the invalidIDs provided.
 * If their payment method is invalid, this function returns true- else it returns false and confirms the validity for the payment method.
 */

const isPaymentBlacklistedFinicityId = (pendingPaymentMethod, invalidIds) => {
  if (pendingPaymentMethod.aggregator === aggregator) {
    const isBlacklisted = invalidIds.filter(
      finId => pendingPaymentMethod.institution_id === finId.id
    );
    if (isBlacklisted.length) {
      return true;
    }
    return false;
  }
  return false;
};

/**
 * Util method that checks the keyboard event and prevents behavior for non-integer values.
 * @param {Event} e This is the event that is created when an input is added to a field.
 * @param {function} isKey A function/utility that parses through keyboard events for readability.
 * @return {function} If the key is within the specified parameters, a function preventing normal behavior is invoked.
 * @return {null} else null is returned {note: this return is added specifically for the linting errors}.
 */

function handleNonIntegerInputs(e, isKey) {
  if (!isKey(e, ["number", "backspace", "delete", "tab"])) {
    return e.preventDefault();
  }
  return null;
}

export {
  formatExpirationMonth,
  isPaymentBlacklistedFinicityId,
  handleNonIntegerInputs
};
